angular.module('impactx.approval').controller('ApprovalChangeAddressController', [
    '$scope',
    '$mdDialog',
    'dataGen',
    'transferredObject',
    'id',
    ApprovalChangeAddressController]);

function ApprovalChangeAddressController($scope, $mdDialog, dataGen, transferredObject, id) {
    
    dataGen.getData($scope, {transferredObject: transferredObject, id: id}, '/approval/changeAddress/view').then(function () {
        $scope.delivery = {adr: $scope.data.deliveryAddress};
        $scope.handover = {adr: $scope.data.handoverAddress};
    });

    $scope.cancel = function() {
        $mdDialog.cancel();
    };

    $scope.save = function() {
        $scope.data.deliveryAddress = $scope.delivery.adr;
        $scope.data.handoverAddress = $scope.handover.adr;
        dataGen.postAsForm($scope, {data: $scope.data}, '/approval/changeAddress/save').then(function () {
            $mdDialog.hide();
        });
    };
}